import React, { useEffect, useState } from 'react';
import imagePlaceholder from '../../assets/images/cars/car-placeholder.png';
import LazyLoad from 'react-lazy-load';

import './CarCardItem.scss'
import { formatPrice, isMobile } from '../../services/shared';
import Button from '../Button/Button';
import ImageCarousel from "../Carousel/ImageCarousel";
import {LeftOutlined, RightOutlined} from "@ant-design/icons";
import { Badge } from 'antd';

const CarCardItem = ({item, itemAction, ctaClass="tertiary",carouselKey}) => {
    const [hasHover, setHasHover] = useState(false);
    const [lander, setLander] = useState('')
    const [showCarouselArrows,setShowCarouselArrows]=useState(false)
    useEffect(() => {
        if (window.location.pathname === "/marketplace") {
            setLander("marketplace")
        }
    }, [])
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 700);


    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 700);

        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div 
            className={`car-card--content-item h-full ${item?.tag==="USED"?'used-car':'new-car'}`} 
            onClick={(event) => itemAction(item, 'BODY',event)}
            onMouseEnter={()=>{
                setHasHover(true);
                setShowCarouselArrows(true)
            }}
            onMouseLeave={()=>{
                setHasHover(false);
                setShowCarouselArrows(false)
            }}
        > {window.location.pathname==="/marketplace" && <Badge.Ribbon text={item?.tag==="USED"?'Used':'New'} className={item?.tag==="USED" ?'used-car-tag-badge':'new-car-tag-badge'}>
        </Badge.Ribbon>}
            <div className="car-card--content-item--static">
                {window.location.pathname!=="/marketplace" && <div className="car-card--content-item--static--img">
                    <LazyLoad offsetVertical={300}>
                        {lander !== "marketplace" ? <img src={item?.imageUrls[0] || imagePlaceholder}/> :
                            <ImageCarousel
                                style={{height:"550px"}}
                                customPrevArrow={(onClickHandler, hasPrev, label)=>{
                                   return( <button
                                        type="button"
                                        className="custom-carousel-arrow custom-arrow-prev"
                                        onClick={onClickHandler}
                                        disabled={!hasPrev}
                                        aria-label={label}
                                    >
                                        <LeftOutlined className="left-arrow-icon"/>
                                    </button>)
                                }
                                }

                                 customNextArrow = {(onClickHandler, hasNext, label) => {return(
                            <button
                            type="button"
                            className="custom-carousel-arrow custom-arrow-next next"
                            onClick={onClickHandler}
                            disabled={!hasNext}
                            aria-label={label}
                            >
                            <RightOutlined className="right-arrow-icon"/>
                            </button>)}}
                                imageUrls={item?.imageUrls}
                            ></ImageCarousel>
                        }
                    </LazyLoad>
                </div>}
                {  lander === "marketplace" &&  <ImageCarousel carouselKey={carouselKey} imageUrls={item?.imageUrls}  customPrevArrow={(onClickHandler, hasPrev, label)=>{
                   return( <button
                       type="button"
                       style={!showCarouselArrows && isDesktop?{display:'none'}:{}}
                       className="custom-carousel-arrow custom-arrow-prev"
                       onClick={onClickHandler}
                       disabled={!hasPrev}
                       aria-label={label}
                   >
                       <LeftOutlined className="left-arrow-icon"/>
                   </button>)
               }}   customNextArrow = {(onClickHandler, hasNext, label) => {return(
                   <button
                       type="button"
                       style={!showCarouselArrows && isDesktop?{display:'none'}:{}}
                       className="custom-carousel-arrow custom-arrow-next next"
                       onClick={onClickHandler}
                       disabled={!hasNext}
                       aria-label={label}
                   >
                       <RightOutlined className="right-arrow-icon"/>
                   </button>)}}></ImageCarousel>}
                <div className="car-card--content-item--static--content flex-auto">
                    <div className="car-card--content-item--static--content--name" style={lander!=="marketplace"?{marginTop:"50px"}:{marginTop:"8px"}}>
                        {`${item?.year} ${item?.make} ${item?.model}`}
                    </div>
                    {
                        item?.tag==="NEW" && (<span className="car-trim">{item.title.split(" - ")[0]}</span>)
                    }
                    {
                        lander === "marketplace" &&

                        <div className="car-card--content-item--static--content--usedcar">
                            {/*<div className="car-card--content-item--static--content--usedcar--topwrap">*/}
                            {/*    <p className="car-card--content-item--static--content--usedcar--topwrap--bodytype">SUV</p>*/}
                            {/*    <div className="flex">*/}
                            {/*        <p className="car-card--content-item--static--content--usedcar--topwrap--vehiclehistory">No*/}
                            {/*            Accidents</p>*/}

                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="car-card--content-item--static--content--usedcar--bottomwrap">
                                <div className="flex">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.3012 3.91913L7.56151 10.0126C7.31494 10.6333 6.89029 11 6.42455 11C6.04099 11 5.71223 10.8025 5.53415 10.4781C5.34237 10.0973 5.35607 9.63178 5.58894 9.23684L9.17792 3.3126C9.356 3.01639 9.72586 2.91765 10.0272 3.07281C10.3286 3.22797 10.4382 3.59471 10.3012 3.91913ZM11.2601 5.6823C11.0546 5.44251 10.6984 5.4284 10.4519 5.65408C10.219 5.86566 10.2053 6.2324 10.4245 6.4863C11.356 7.53009 11.8765 8.89831 11.8765 10.3512C11.8765 10.6756 12.1368 10.9295 12.4381 10.9295C12.7532 10.9295 12.9998 10.6615 12.9998 10.3512C13.0135 8.6021 12.397 6.93767 11.2601 5.6823ZM6.95878 4.70903C7.27385 4.73724 7.53412 4.51155 7.56151 4.18713C7.58891 3.86271 7.36974 3.59471 7.05467 3.5665C6.87659 3.55239 6.68482 3.53829 6.50674 3.53829C2.91776 3.53829 0 6.59914 0 10.3512C0 10.6756 0.260269 10.9295 0.561634 10.9295C0.862999 10.9295 1.12327 10.6615 1.12327 10.3512C1.12327 7.23388 3.53419 4.69492 6.49304 4.69492C6.65742 4.68082 6.8218 4.69492 6.95878 4.70903Z"
                                            fill="#ABABAB"/>
                                    </svg>
                                    {item?.tag==="USED" ? <p className="car-card--content-item--static--content--usedcar--bottomwrap--miles">{item?.mileage} miles</p>:<p className="car-card--content-item--static--content--usedcar--bottomwrap--miles">{item?.mileageHwy}/{item?.mileageCity} MILEAGE-HWY/CITY</p>}
                                </div>
                                {/*<div className="flex">*/}
                                {/*    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"*/}
                                {/*         xmlns="http://www.w3.org/2000/svg">*/}
                                {/*        <path*/}
                                {/*            d="M5.25002 1.16669C3.72169 1.16669 2.47919 2.40919 2.47919 3.93752C2.47919 5.43669 3.65169 6.65002 5.18002 6.70252C5.22669 6.69669 5.27335 6.69669 5.30835 6.70252C5.32002 6.70252 5.32585 6.70252 5.33752 6.70252C5.34335 6.70252 5.34335 6.70252 5.34919 6.70252C6.84252 6.65002 8.01502 5.43669 8.02085 3.93752C8.02085 2.40919 6.77835 1.16669 5.25002 1.16669Z"*/}
                                {/*            fill="#ABABAB"/>*/}
                                {/*        <path*/}
                                {/*            d="M8.21331 8.25418C6.58581 7.16918 3.93164 7.16918 2.29248 8.25418C1.55164 8.75001 1.14331 9.42085 1.14331 10.1383C1.14331 10.8558 1.55164 11.5208 2.28664 12.0108C3.10331 12.5592 4.17664 12.8333 5.24998 12.8333C6.32331 12.8333 7.39664 12.5592 8.21331 12.0108C8.94831 11.515 9.35664 10.85 9.35664 10.1267C9.35081 9.40918 8.94831 8.74418 8.21331 8.25418Z"*/}
                                {/*            fill="#ABABAB"/>*/}
                                {/*        <path*/}
                                {/*            d="M11.6608 4.28168C11.7542 5.41335 10.9492 6.40502 9.835 6.53918C9.82917 6.53918 9.82917 6.53918 9.82334 6.53918H9.80584C9.77083 6.53918 9.73583 6.53918 9.70667 6.55085C9.14083 6.58002 8.62167 6.39918 8.23083 6.06668C8.83167 5.53002 9.17584 4.72502 9.10584 3.85002C9.065 3.37752 8.90167 2.94585 8.65667 2.57835C8.87834 2.46752 9.135 2.39752 9.3975 2.37418C10.5408 2.27502 11.5617 3.12668 11.6608 4.28168Z"*/}
                                {/*            fill="#ABABAB"/>*/}
                                {/*        <path*/}
                                {/*            d="M12.8275 9.67751C12.7808 10.2433 12.4192 10.7333 11.8125 11.0658C11.2292 11.3867 10.4942 11.5383 9.76499 11.5208C10.185 11.1417 10.43 10.6692 10.4767 10.1675C10.535 9.44417 10.1908 8.75001 9.5025 8.19584C9.11166 7.88667 8.65666 7.64167 8.16083 7.46084C9.44999 7.08751 11.0717 7.33834 12.0692 8.14334C12.6058 8.57501 12.88 9.11751 12.8275 9.67751Z"*/}
                                {/*            fill="#ABABAB"/>*/}
                                {/*    </svg>*/}
                                {/*    <p className="car-card--content-item--static--content--usedcar--bottomwrap--owners">2*/}
                                {/*        Owners</p>*/}
                                {/*</div>*/}
                                {/*<div className="flex">*/}
                                {/*    {item?.tag &&   <p className="car-card--content-item--static--content--usedcar--topwrap--usedcartag" style={{background:"green"}}>{item?.tag}</p>}*/}
                                {/*    {item?.carfaxReport &&   <p className="car-card--content-item--static--content--usedcar--topwrap--certify">CLEAN CARFAX</p>}*/}
                                {/*</div>*/}
                            </div>

                        </div>

                    }
                    <div className="flex" style={window.location.pathname==="/marketplace"?{borderTop: "2px solid #C3D4E966",padding:"0px"
                    }:{}}>
                        <div className="car-card--content-item--static--content--price" style={window.location.pathname==="/marketplace"?{borderRight: "2px solid #C3D4E966",marginRight:"10px",marginTop:"8px"}:{}}>
                            {
                                !item.isSubmitted ?
                                <div>
                                    <div>Starting at MSRP*</div>
                                    <div className={`car-card--content-item--static--content--price--value ${isMobile() ?'strike':''}`}>${formatPrice(item?.price)}</div>
                                </div> :
                                <>Dealers will be contacting you soon for this car.</>
                            }
                        </div>
                        {
                            !item.isSubmitted &&
                            <Button
                                loaderHeight={30}
                                loaderWidth={lander !== "markerplace" ? 30 : 148}
                                loading={item.isFormSubmitting}
                                onClick={() => {
                                    window.dataLayer?.push({
                                        'event': lander === "marketplace" ? "Select Request info":"Get Offers",
                                        'event_product_selection':item
                                    })
                                    itemAction(item, 'CTA')}}
                                className={`flex-1 car-card--content-item--action ${ctaClass} ${hasHover ? 'hover' : ''}`}>
                                {item?.isSubmitted ? 'Submitted' : (lander != "marketplace" ? 'Get Offers' : "Request Info")}
                            </Button>
                        }
                    </div>
                    
                </div>
                
            </div>
            
        </div>
    )
}

export default CarCardItem;